// ClassSelect.js
import React, { useState, useEffect } from 'react';
import AppStrings from '../config/appstring';

const AdmissionTypeSelect = ({ value, onChange }) => {
  const [classOptions, setClassOptions] = useState([]); // To store class options fetched from the API

  useEffect(() => {
    const fetchClassDetails = async () => {
      try {
        console.log('KKKKKKKKKKKKKKKKKKKK');
        const response = await fetch("https://school.agnisofterp.com/agni/addmission/detail");
        const data = await response.json(); // Assuming the response is in JSON format
console.log(data.data,'KKKKKKKKKKKKKKKKKKKK555555555555');
        if (data.success === 200 && Array.isArray(data.data)) {
          setClassOptions(data.data); // Set the class options
        } else {
          console.error('Invalid data format received:', data);
        }
      } catch (error) {
        console.error('Error fetching class details:', error);
      }
    };

    fetchClassDetails();
  }, []); // Empty dependency array to fetch data once on component mount

  return (
    <div>
        
          <div class="coolinput">
      <label for="input" class="text">Admission Type</label>
      <select
        name="ADMISSION"
        value={value} // Controlled component
        onChange={onChange} // Passing onChange to parent
        className="input"
        autoComplete="off"
      >
        <option value="">SELECT</option>
        {classOptions.map((classItem, index) => (
          <option key={index} value={classItem.ADMISSION}>
            {classItem.ADMISSION || ''}
          </option>
        ))}
      </select>
      </div>
    </div>
  );
};

export default AdmissionTypeSelect;




